import axios from "axios";
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

const m3uPlaylistURL = async (url) => {
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const m3uParseData = (data) => {
  return (dispatch) => {
    dispatch({
      type: "M3U_PARSE_DATA",
      payload: data,
    });
  };
};

export const M3UPlaylistCategory = (data) => {
  return (dispatch) => {
    dispatch({
      type: "M3U_PLAYLIST_CATEGORY",
      payload: data,
    });
  };
};

export default m3uPlaylistURL;
